export default "__VITE_ASSET__hKEH6KBX__"